import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FAddressCard from "../../components/FAddressCard/FAddressCard";
import { getAddress, deleteAddressById } from "../../api/address";
import Floading from "../../components/Floading/Floading";

import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";
import { useAddress } from "../../hooks/useAddress";
import { BriefcaseOutline, EllipsisHorizontalCircle, HomeOutline } from "react-ionicons";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import { size } from "lodash";
import Switch from "react-switch";
import VectorIcons from "../../components/VectorIcons/VectorIcons";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const AddressScreen = ({ param }) => {
  const MySwal = withReactContent(Swal);

  const { addresses, getAddresses, deleteAddress, editAddress } = useAddress();
  const route = useNavigate();

  useEffect(() => {
    getAddresses();
  }, []);

  const onDeleteClickAddress = (data) => {
    Swal.fire({
      showCloseButton: true,
      title: "Eliminar dirección",
      text: "¿Está seguro que desea eliminar esta dirección?",
      imageUrl: require("../../components/assets/images/pregunta.png"),
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Custom image",
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAddress(data.address.id);
      }
    });
  };

  return (
    <>
      <FBannerTitleButton
        title="Agrega direcciones a tu cuenta"
        imageUrl={require("../../components/assets/images/address.png")}
        titleButton={
          <Fbutton
            value="Continuar"
            onClick={() => {
              route("/CreateAddressScreen");
            }}
          />
        }
      />
      <FContainer>
        {addresses.length > 0
          ? addresses
            .sort((a, b) => Number(b.address.isPrincipal) - Number(a.address.isPrincipal))
            .map((address) => (
              <>
                <FAddressCard
                  address={address}
                  className="text-[3.5vw] smm:text-[16px] cursor-pointer"
                  enableButtonDelete={true}
                  onDeleteAddress={(addres) => {
                    onDeleteClickAddress(addres);
                  }}
                  onEditAddress={() => {
                    MySwal.fire({
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      html: <MySwalSalveDirection data={address} MySwal={MySwal} getAddresses={getAddresses} editAddress={editAddress} />,
                    });
                  }}
                />
              </>
            ))
          : null}
      </FContainer>
    </>
  );
};

const MySwalSalveDirection = ({ data, MySwal, getAddresses, editAddress }) => {

  const [principal, setPrincipal] = useState(data.address.isPrincipal);
  const [typeOfAddressId, setTypeOfAddressId] = useState(data.address.typeOfAddressId);
  const [tag, setTag] = useState(data.address.tag);

  const nextScreen = async (data) => {
    if ((await editAddress(data)) === true) {
      Swal.fire({
        showCloseButton: true,
        icon: 'success',
        title: "Actualización exitosa",
        showConfirmButton: false,
        timer: 1500
      })
      getAddresses()
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo crear tu dirección",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };


  return (
    <>
      <div className="border-0 w-full font-bold mt-5 text-[5vw] xxs:text-[17px]">
        <Switch
          onColor="#F10C8F"
          onChange={() => {
            if (!data.address.isPrincipal) {
              setPrincipal(!principal);
            }
          }}
          checked={principal}
        />
        {" Marcar como dirección principal"}
      </div>
      <div className="border-0 cursor-pointer w-full grid grid-cols-3 place-items-center mt-5">
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "HOME" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("HOME");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
            <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <HomeOutline
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "HOME" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4.5vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "HOME"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Casa
            </div>
          </div>
        </div>
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "WORK" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("WORK");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
            <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <BriefcaseOutline
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "WORK" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "WORK"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Trabajo
            </div>
          </div>
        </div>
        <div
          className={`col-span-1 border-2 rounded-xl ${typeOfAddressId == "OTHER" ? "shadow-Box" : ""
            }`}
          onClick={() => {
            setTag(null)
            setTypeOfAddressId("OTHER");
          }}
        >
          <div className="border-0 grid grid-cols-1 p-2">
          <div className="border-0 w-full col-span-1 grid place-items-center">
              <div className="w-[6vw] h-[6vw] xxs:w-[21px] xxs:h-[21px]">
                <EllipsisHorizontalCircle
                  cssClasses={"!w-full !h-full"}
                  color={typeOfAddressId == "OTHER" ? "#F10C8F" : "#A0A0A0"}
                />
              </div>
            </div>
            <div
              className={`border-0 col-span-1 text-[4.5vw] xxs:text-[14px] grid place-items-center ${typeOfAddressId == "OTHER"
                ? "font-bold text-Secondary"
                : "text-[#A0A0A0]"
                }`}
            >
              Otro
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      {
        typeOfAddressId == "OTHER" ? (
          <div className="text-left">
            <FInputText
              title="Descripción"
              placeholder="Ej: Casa de mis padres"
              value={!tag ? "" : tag}
              onChange={(value) => {
                setTag(value == "" ? null : value)
              }}
            /></div>) : null
      }

      <Fbutton
        value="Guardar"
        onClick={() => {
          data.isPrincipal = principal;
          data.typeOfAddressId = typeOfAddressId;
          data.tag = tag;

          let _data = {
            id: data.address.id,
            typeOfAddressId: typeOfAddressId,
            isPrincipal: principal,
            tag: tag
          }

          nextScreen(_data);
        }}
      // disabled={size(data) > 0 ? false : true}
      />
    </>
  );
};

export default AddressScreen;
